import { createUseStyles } from 'react-jss';

import { zBatchCrop } from 'utils/ui-helpers/stackingContexts';
import { ITheme } from 'types';

const useStyles = createUseStyles((theme: ITheme) => ({
  gridImageWrap: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: props => props?.width,
    height: props => props?.height,
    background: 'var(--transparent-background-image)',
  },
  gridImage: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100%',
  },
  cropActive: {
    zIndex: zBatchCrop,
  },
  cropWrap: {
    position: 'absolute',
    top: theme.spacings.s0,
    left: theme.spacings.s0,
    right: theme.spacings.s0,
    bottom: theme.spacings.s0,
  },
}));

export default useStyles;
